import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import CoachingIcon from '../../../ExperienceCatalog/Experience/OfferingType/Coaching/CoachingIcon';

interface Props {
  children?: React.ReactNode;
}

function CoachingLabel({ children }: Props) {
  return (
    <div className="relative w-min flex items-center rounded-2xl border-teal-600 text-teal-600 px-3 py-1 text-xs border">
      <span className="mr-2">
        <CoachingIcon />
      </span>
      <span className="mr-2">
        <T kind="Coaching" />
      </span>
      {children}
    </div>
  );
}

export default observer(CoachingLabel);
